import { Link } from "react-router-dom";
import GlobalState from "../contexts/GlobalState";
import { useContext } from "react";
import BlueArrow from "./icons/blue-arrow";

export default function SingleListElement({ single, index }) {

  const { generalDataGlobal } = useContext(GlobalState);
  const locale = localStorage.getItem('language');

  return (
    <div
      key={single.id}
      className={`row home-list-row  ${
        index % 2 === 0 ? "flex-row" : "flex-row-reverse"
      }`}
    >
      <div className="col-lg-6 mb-3 mb-lg-0 d-flex align-items-center">
        <div className="h-100 w-100">
          {single.video ? (
            <video
              src={single.video_path}
              type="video/mp4"
              className="video-map cover h-100 w-100"
              autoPlay
              muted
              loop
            ></video>
          ) : single.image ? (
            <img
              src={single.image_path}
              alt="list element"
              className="home-list-image h-100 w-100"
            />
          ) : (
            <></>
          )}
        </div>
        {/* <div className="h-100 w-100 d-xl-none">
          {single.image ? (
            <img
              src={single.image_path}
              alt="list element"
              className="home-list-image w-100 h-100"
            />
          ) : (
            <></>
          )}
        </div> */}
      </div>
      <div className="col-lg-6">
        <div
          className={`home-list-content ${index % 2 === 0 ? "blue" : "white"}`}
        >
          <p
            className={`home-list-title ${index % 2 === 0 ? "white" : "blue"}`}
          >
            {single.title}
          </p>
          <div
            className={`home-list-description mb-5 ${
              index % 2 === 0 ? "white" : "blue"
            }`}
            dangerouslySetInnerHTML={{
              __html: single.description,
            }}
          ></div>
          {single.link ? (
            <Link to={`/${locale}/${single.link}`}>
              <div className="d-flex align-items-center">
                <p className="view-resource me-1">{single?.learn_more_label}</p>
               <BlueArrow/>
              </div>
            </Link>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
